import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Alert, AlertTitle, Button } from '@mui/material';

const propTypes = {

}

const defaultProps = {

}

const TeamRequirementsBanner = (props) => {
  return (
    <Alert
      severity="warning"
      action={
        <Button color="inherit" size="small" href="/admin/users/new">
          Crear usuario
        </Button>
      }
    >
      <AlertTitle>
        Para poder crear un Team se requiere uno o más usuarios que cumplan las siguientes condiciones:
      </AlertTitle>
      <ul className="p0 mb0">
        <li>No debe tener rol de admin.</li>
        <li>No debe ser mensajero.</li>
        <li>No debe tener otro Team asignado.</li>
      </ul>
    </Alert>
  )
};

TeamRequirementsBanner.propTypes = propTypes;
TeamRequirementsBanner.defaultProps = defaultProps;

export default TeamRequirementsBanner;